import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { ListGroupComponentProps, ListGroupComponentHandler, ListGroupComponentState } from './listgroupcomponent';
import * as React from 'react';
import { ListGroupCSSStyle } from './listgroupcss';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';
import { ListGroupViewModelImpl } from './viewmodel/grouprow/listgroupviewmodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { VerticalListComponent } from '../../../../toolkit/verticallist/verticallistcomponent';
import './groups-listing-style.css';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';

export class ListGroupViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popupComponent: PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;


    bindHandlers()
    {
        this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.showDeletePopup = this.showDeletePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
    }
    constructor(private viewModel:ListGroupViewModelImpl, applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
  {
      super(applicationContext, uiComponentHandler);


    //   this.viewModel = new ListGroupViewModelImpl(5, applicationContext);
  }

    
    draw(props: ListGroupComponentProps, state: ListGroupComponentState, cssStyle: ListGroupCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div id="groups-list-main" style={cssStyle.getWrapperCSSStyle()}>
                <div id="groups-list-title" style={cssStyle.getCallerHeaderTitle()}>
                    {this.getContext().getResources().getString(Strings.my_caller_group)}
                </div>
                <p id="groups-list-description" style={cssStyle.getCallerDescriptionDivCSSStyle()}>
                    {this.getContext().getResources().getString(Strings.create_and_manage_group_msg)}
                </p>
                <div id="groups-list" style={{textAlign:'center',display:'inline-block'}}>
                {  
                  
                  state.listOfGroup.length > 0 ?
                  this.getHeader(props,cssStyle): this.getCreateButton(props,cssStyle)

                } 
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>

                 <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>

            </div>
        );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }
    showDeletePopup(msg: string, type: AlertType,title:string,groupDto:GroupDto)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={(e)=>this.deleteConfirm(groupDto)} context={this.getUIProps().context}/>);
        
    }
    hidePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }

    private deleteConfirm(groupDto:GroupDto)
    {
        this.hidePopup();
        
        (this.getUIComponentHandler() as ListGroupComponentHandler).onDeleteConfirm(groupDto);
    }
    private getHeader(props:ListGroupComponentProps, cssStyle:ListGroupCSSStyle):JSX.Element
    {
        return(
            <>
            <div style={cssStyle.getListHeaderWrapperDivCSSStyle()}>
            <div style={cssStyle.getListTitleDivCSSStyle()}>
                  <label id="groups-list-label" style={cssStyle.getListLabelCSSStyle()}>
                       {this.getContext().getResources().getString(Strings.group_list)}
                  </label>
            </div>
            <div style={cssStyle.getButtonDivCSSStyle()}>
               <div onClick={this.onCreateButtonClick} style={cssStyle.getCreateButtonDivCSSStyle("55%")}>
                       <ButtonComponent label={props.context.getResources().getString(Strings.create_group)} style={new ButtonCSSStyleImpl(props.context)} onClick={() =>{}} context={props.context}/>
               </div>
           </div>
       </div>
             
            <div style={{ width: "100%",textAlign: "center",display:'inline-block'}}>
                 {  
                       this.getGroupList(props,this.getUIState() as ListGroupComponentState)
                 }   
                 </div> 
       </>
        );
    }
    private getCreateButton(props:ListGroupComponentProps, cssStyle:ListGroupCSSStyle):JSX.Element
    {
        return(
            <div onClick={this.onCreateButtonClick} style={cssStyle.getCreateButtonDivCSSStyle("30%")}>
            <ButtonComponent label={props.context.getResources().getString(Strings.create_group)} style={new ButtonCSSStyleImpl(props.context)} onClick={() =>{}} context={props.context}/>
           </div>
        );
       
    }
    private getGroupList(props:ListGroupComponentProps,state:ListGroupComponentState):JSX.Element
    {
        this.viewModel.setListDatas(state.listOfGroup);
        return(  <VerticalListComponent listViewModel={this.viewModel} context={props.context}/>);
    }

    private onCreateButtonClick():void
    {                        
        (this.getUIComponentHandler() as ListGroupComponentHandler).onCreateButtonClick();
    }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/listgroupview.tsx